import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { Form, Input } from "antd";
import IntlMessages from "@lib/helpers/IntlMessages";
import {
  SignInButton,
  StyledRememberMe,
  StyledSign,
  StyledSignContent,
  StyledSignForm,
  StyledSignLink,
} from "../index.styled";
import AppPageMeta from "@lib/components/AppComponents/AppPageMeta";
import { useTypedDispatch } from "@lib/redux";
import { ErrorMessages } from "@lib/types/General";
import { useEffect, useState } from "react";
import { AuthUser } from "@lib/types/Auth";
import { createYupSync } from "@lib/helpers/TableHelper";
import { signInSchema as yupSchema } from "@lib/schemas/auth";
import { useAuthQueries } from "@lib/apiQueries";
import { AppLayout } from "@lib/components/AppComponents";
import { NavStyle } from "@lib/constants/AppEnums";

const initialValues = {
  email: "",
  password: "",
};

const SignIn = () => {
  const { messages } = useIntl();
  const navigate = useNavigate();
  const dispatch = useTypedDispatch();
  const [form] = Form.useForm();
  const [formData, setFormData] = useState<Partial<AuthUser>>();

  const { signInMutation } = useAuthQueries({
    navigate,
    dispatch,
    messages,
  });
  const { mutate, isPending, error } = signInMutation;

  useEffect(() => {
    if (error?.message == ErrorMessages.TwoFactorAuthenticationRequired) {
      navigate("/auth/two-factor", {
        state: { values: formData },
      });
      return;
    }
  }, [error]);

  const onGoToForgetPassword = () => {
    // navigate("/forget-password", { tab: "jwtAuth" });
  };

  return (
    <AppLayout overrideLayout={NavStyle.NON_AUTH}>
      <AppPageMeta title={messages["common.signIn"] as string} />

      <StyledSign>
        <StyledSignContent>
          <StyledSignForm
            name="sign-in-form"
            form={form}
            initialValues={initialValues}
            onFinish={(values: any) => {
              setFormData(values);
              mutate({
                username: values.email,
                password: values.password,
              });
            }}
          >
            <Form.Item
              name="email"
              className="form-field"
              rules={[createYupSync({ schema: yupSchema })]}
            >
              <Input placeholder={messages["common.email"] as string} />
            </Form.Item>

            <Form.Item
              name="password"
              className="form-field"
              rules={[createYupSync({ schema: yupSchema })]}
            >
              <Input.Password
                placeholder={messages["common.password"] as string}
              />
            </Form.Item>

            <StyledRememberMe>
              <StyledSignLink onClick={onGoToForgetPassword}>
                <IntlMessages id="common.forgetPassword" />
              </StyledSignLink>
            </StyledRememberMe>

            <div className="form-btn-field">
              <SignInButton
                type="primary"
                htmlType="submit"
                loading={isPending}
              >
                <IntlMessages id="common.login" />
              </SignInButton>
            </div>
          </StyledSignForm>
        </StyledSignContent>
      </StyledSign>
    </AppLayout>
  );
};

export default SignIn;
